export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7c37594ec4a632e658e6387accfdd24e.jpg"
          alt="AMYMAISON Hero"
          className="w-full h-full object-cover object-top"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 flex flex-col lg:flex-row items-center lg:items-end gap-10 lg:gap-0 pb-16 pt-24">
        {/* Left: Main Copy */}
        <div className="flex-1 flex flex-col gap-6">
          <span className="inline-flex items-center border border-white/50 text-white/80 text-xs tracking-widest px-4 py-1.5 rounded-full w-fit">
            Scent Marketing Brand
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light text-white leading-tight tracking-wide">香りの力で、記憶に残す。<br />本能を動かす。</h1>
          <div className="flex items-center gap-4 mt-2">
            <button
              onClick={() => handleScroll('#concept')}
              className="bg-white text-stone-900 text-xs tracking-widest px-6 py-3 rounded-full font-medium hover:bg-stone-100 transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              詳しく見る
            </button>
            <button
              onClick={() => handleScroll('#contact')}
              className="text-white/80 text-xs tracking-widest underline underline-offset-4 hover:text-white transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              CONTACT へ
            </button>
          </div>
        </div>


      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest">SCROLL</span>
        <div className="w-px h-8 bg-white/30" />
      </div>
    </section>
  );
}
